export default __webpack_public_path__ + "static/media/analytics.5aa0786a.svg";